import React, {  useContext, useState } from 'react';
import { DataComplaintContext, ShowComplaintsContext } from './types';
import ButtonsForm from '../../HtmlComponents/ButtonsForm';
import InputsComplaint from './forms/InputsComplaint';
import { useDispatch } from 'react-redux';
import { AddComplaintApi } from '../../redux/complaints/complaintApiCalls';
import { Timeout } from '../../functions/functions';
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg';

interface AddComplaintInterface {
  modal: boolean,
  toggle: () => void,
}

const AddComplaint:React.FC<AddComplaintInterface> = ({ modal, toggle }) => {
  const [fullName, setFullName] = useState<string>("")
  const [phone, setPhone] = useState<string>("")
  const [RegNo, setRegNo] = useState<string>("")
  const [cabinetName, setCabinetName] = useState<string>("")
  const [doctorName, setDoctorName] = useState<string>("")
  const [devis, setDevis] = useState<File | any>(null)
  const [message, setMessage] = useState<string>("")
  const [view, setView] = useState(false)


  const [errors, setErrors] = useState<string[]>([])

  const [loading, setLoading] = useState(false)

  const { setShowSuccessMsg } = useContext(ShowComplaintsContext)
  const dispatch:any = useDispatch()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("fullName", fullName)
      formData.append("phone", phone)
      formData.append("RegNo", RegNo)
      formData.append("cabinetName", cabinetName)
      formData.append("doctorName", doctorName)
      formData.append("devis", devis)
      formData.append("message", message)
      formData.append("view", JSON.stringify(view))

      const response: any = await dispatch(AddComplaintApi(formData))
        if(response === true) {
          setFullName("")
          setPhone("")
          setRegNo("")
          setCabinetName("")
          setDoctorName("")
          setDevis(null)
          setMessage("")
          setView(false)
          setShowSuccessMsg(true)
          setErrors([])
          toggle()
          setTimeout(() => setShowSuccessMsg(false), Timeout)
        } else {
          setErrors(response)
        }
    } finally {
      setLoading(false)
    }
  }

  return (
    <DataComplaintContext.Provider 
      value={{
        fullName, setFullName,
        phone, setPhone,
        RegNo, setRegNo,
        cabinetName, setCabinetName,
        doctorName, setDoctorName,
        devis, setDevis,
        message, setMessage,
        view, setView,
      }}
    >      
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                    encType='multipart/form-data'
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors} />
                    <InputsComplaint />
                    <ButtonsForm loading={loading} toggle={toggle} typeBtn='Ajouter' />
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </DataComplaintContext.Provider>
  );
}

export default AddComplaint
